/**
 * Zentraler Auth-Speicher.
 *
 * „Angemeldet bleiben" (remember=true)  → localStorage (übersteht Browser-/Tab-Schließen).
 * Nicht merken       (remember=false)   → sessionStorage (Logout beim Schließen).
 *
 * Gelesen wird immer aus beiden Speichern (localStorage bevorzugt), damit alle
 * token-abhängigen Aufrufe unabhängig von der Wahl funktionieren.
 */
const TOKEN_KEY = 'token';
const USER_KEY = 'user';
const REMEMBER_KEY = 'auth_remember';
const LOGOUT_REASON_KEY = 'auth_logout_reason';

export const getToken = () =>
  localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

export const getUser = () =>
  localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);

export const isRemembered = () => localStorage.getItem(REMEMBER_KEY) === '1';

const _serialize = (user) =>
  typeof user === 'string' ? user : JSON.stringify(user);

export const setSession = (token, user, remember = true) => {
  const store = remember ? localStorage : sessionStorage;
  const other = remember ? sessionStorage : localStorage;
  store.setItem(TOKEN_KEY, token);
  if (user !== undefined && user !== null) {
    store.setItem(USER_KEY, _serialize(user));
  }
  // Duplikate im anderen Speicher entfernen
  other.removeItem(TOKEN_KEY);
  other.removeItem(USER_KEY);
  if (remember) localStorage.setItem(REMEMBER_KEY, '1');
  else localStorage.removeItem(REMEMBER_KEY);
};

/** Nur das User-Objekt im aktiven Speicher aktualisieren (Token bleibt). */
export const updateUser = (user) => {
  const store = localStorage.getItem(TOKEN_KEY) ? localStorage : sessionStorage;
  store.setItem(USER_KEY, _serialize(user));
};

export const clearSession = () => {
  [localStorage, sessionStorage].forEach((s) => {
    s.removeItem(TOKEN_KEY);
    s.removeItem(USER_KEY);
  });
  localStorage.removeItem(REMEMBER_KEY);
};

/** Grund einer automatischen Abmeldung merken (für Hinweis auf der Login-Seite). */
export const setLogoutReason = (reason) => {
  try {
    sessionStorage.setItem(LOGOUT_REASON_KEY, reason);
  } catch { /* ignore */ }
};

/** Grund einmalig auslesen und löschen. */
export const consumeLogoutReason = () => {
  try {
    const r = sessionStorage.getItem(LOGOUT_REASON_KEY);
    if (r) sessionStorage.removeItem(LOGOUT_REASON_KEY);
    return r;
  } catch {
    return null;
  }
};
